function debounce(func, timeout = 300){
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => { func.apply(this, args); }, timeout)
  };
}

function reloadWishlist() {
  typeof window.ReloadSmartWishlist === 'function' && window.ReloadSmartWishlist()
}

window.addEventListener('perform-dynamic-search', debounce(reloadWishlist, 2000))
window.addEventListener('side-menu:opened', onSideMenuOpened)
window.addEventListener('side-menu:closed', onSideMenuClosed)

function onSideMenuOpened() {
  hideChatBtn()
}

function onSideMenuClosed() {
  showChatBtn()
}

/* Support chat button */
function hideChatBtn () {
  document.getElementById('dummy-chat-button-iframe')?.classList.add('hidden')
}
function showChatBtn () {
  document.getElementById('dummy-chat-button-iframe')?.classList.remove('hidden')
}

/* Improve CLS on font load */
Promise.all([
  document.fonts.load('1rem "Lato"'), 
]).then(() => {
  if (document.fonts.check('1rem "Lato"')) {
    document.body.classList.add('font-lato-loaded');
  }
});